import WithdrawnLeadsFileAccessSnapshot from './WithdrawnLeadsFileAccessSnapshot.component';

export default WithdrawnLeadsFileAccessSnapshot;
